import React from 'react'
import {Box, Button, Card, Chip, Typography} from '@mui/material'
import {AutoAwesome as SparkleIcon} from '@mui/icons-material'
import type {SiteBuilderPlanData} from './types'

interface SiteBuilderPlanCardProps {
  data: SiteBuilderPlanData
  onApprove: (message: string) => void
}

const SiteBuilderPlanCard: React.FC<SiteBuilderPlanCardProps> = ({data, onApprove}) => (
  <Box sx={{mt: 2, display: 'flex', flexDirection: 'column', gap: 1.5}}>
    {data.sections.map((section, i) => (
      <Card
        key={i}
        variant="outlined"
        sx={{
          px: 2,
          py: 1.5,
          borderRadius: 2,
          borderColor: 'divider',
          bgcolor: 'background.paper'
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 0.5}}>
          <Typography variant="body2" fontWeight={700}>
            {section.title}
          </Typography>
          <Chip
            label={section.vizType}
            size="small"
            variant="outlined"
            color="primary"
            sx={{height: 20, fontSize: '0.65rem'}}
          />
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{display: 'block', lineHeight: 1.5}}>
          {section.dataRationale}
        </Typography>
        <Typography variant="caption" color="text.disabled" sx={{display: 'block', mt: 0.5, fontStyle: 'italic'}}>
          {section.toneNote}
        </Typography>
      </Card>
    ))}

    <Button
      variant="contained"
      size="small"
      startIcon={<SparkleIcon sx={{fontSize: 16}} />}
      onClick={() => onApprove('Looks good, let\'s build it')}
      sx={{
        textTransform: 'none',
        alignSelf: 'flex-start',
        mt: 0.5,
        borderRadius: 2,
        px: 2.5
      }}
    >
      Approve & Start Building
    </Button>

    <Typography variant="caption" color="text.secondary" sx={{mt: -0.5}}>
      Or describe changes in the chat below
    </Typography>
  </Box>
)

export default SiteBuilderPlanCard
